import { render, staticRenderFns } from "./BaseIconButtonAssignment.vue?vue&type=template&id=20a05cdc&scoped=true&"
import script from "./BaseIconButtonAssignment.vue?vue&type=script&lang=js&"
export * from "./BaseIconButtonAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a05cdc",
  null
  
)

export default component.exports